module.exports = "::ng-deep .tooltip-inner {\n  border: 1px solid #999296;\n  background: #fff; }\n"